<template>
  <div class="mb-8">
    <h3 class="mb-8">
      {{ $t('appointment.confirmAppointment.details') }}
    </h3>

    <v-progress-linear v-show="isLoading" color="realEstate" indeterminate />

    <div v-show="!isLoading && hasConfirmationData">
      <v-row no-gutters>
        <v-col cols="12" md="7">
          <h6 class="text-uppercase grey--text">
            {{  $t('appointment.confirmAppointment.agency') }}
          </h6>
          <p class="body-2">
            {{ confirmAppointmentData.branch ? confirmAppointmentData.branch.name : '---' }}
          </p>
        </v-col>
        <v-col cols="12" md="5">
          <h6 class="text-uppercase grey--text">
            {{  $t('appointment.confirmAppointment.scheduledBy') }}
          </h6>
          <p class="body-2">
            {{ confirmAppointmentData.scheduled_by }}
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="7">
          <h6 class="text-uppercase grey--text">
            {{  $t('appointment.confirmAppointment.code') }}
          </h6>
          <p class="body-2">
            {{ confirmAppointmentData.code }}
          </p>
        </v-col>
        <v-col cols="12" md="5">
          <h6 class="text-uppercase grey--text">
            {{  $t('appointment.confirmAppointment.name') }}
          </h6>
          <p class="body-2">
            {{ confirmAppointmentData.tenant_name ? confirmAppointmentData.tenant_name : '---' }}
          </p>
          <!-- old date place -->
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentConfirmDetails',

  computed: {
    ...mapGetters(['confirmAppointmentData', 'isLoading']),

    hasConfirmationData() {
      return this.confirmAppointmentData.branch && this.confirmAppointmentData.code
    },
  },
}
</script>
